export default __webpack_public_path__ + "media/images/info_warning_16_copy-0c980671dce01d7148f6a489f3cb97e0.png";